import Input from '@/components/Input/Input';
import { HStack } from '@/components/Layout';
import { ControlledSelect } from '@/components/Select/ControlledSelect';
import { Text } from '@/components/Typography/Text';
import { formatCurrency } from '@/utils/currency';
import { CFormItemBase, type CFormItemProps, buildCFormItem } from '../CFormItem';
type CurrencyOption = {
  value: string;
  label: string;
};
type Props = CFormItemProps & {
  value?: number;
  onChange?: (value?: number) => void;
  inputClassName?: string;
  allowNegative?: boolean;
  currencyCode: string;
  onCurrencyChange?: (currencyCode: string) => void;
  /**
   * 通貨セレクタの選択肢。`onCurrencyChange` と併用する。
   * 渡されない場合はセレクタを出さず静的表示する。
   */
  currencyOptions?: CurrencyOption[];
  locale?: string;
  step?: number;
};

/**
 * Card-based Form / CurrencyItem
 * 金額を扱うためのフォームアイテム
 * onCurrencyChange と currencyOptions を渡した場合、write モードで通貨セレクタを表示する
 */
export const CFormCurrencyItem = buildCFormItem((props: Props) => {
  const showCurrencySelector = !!props.onCurrencyChange && !!props.currencyOptions;
  return <CFormItemBase {...props} readComponent={<Text variant="p">
          {props.value !== undefined ? formatCurrency({
      amount: props.value,
      currencyCode: props.currencyCode,
      locale: props.locale
    }) : '-'}
        </Text>} writeComponent={<HStack className="gap-2 items-center">
          <Input type="number" inputMode="decimal" min={props.allowNegative ? undefined : 0} step={props.step ?? '0.01'} value={props.value ?? ''} onChange={e => {
      const value = e.target.value === '' ? undefined : parseFloat(e.target.value);
      props.onChange?.(value);
    }} className={props.inputClassName ?? 'w-[120px]'} />
          {showCurrencySelector ? <ControlledSelect id={`${props.id}-currency`} value={props.currencyCode || undefined} onChange={option => props.onCurrencyChange?.(option?.value ?? '')} fetchOptions={async () => props.currencyOptions ?? []} hideSearch={(props.currencyOptions?.length ?? 0) <= 10} allowEmpty={!props.required} disabled={props.readonly} /> : <Text variant="labelReg">{props.currencyCode}</Text>}
        </HStack>} />;
});